import { endOfMonth, startOfMonth, subDays, subMonths } from "date-fns";
import { defineMessage } from "react-intl";

const now = new Date();

export type DateRange = [Date, Date];
export type PresetDateRangeKey = "thisPeriod" | "lastPeriod" | "last14" | "last7";
export interface PresetDateRange {
  message: ReturnType<typeof defineMessage>;
  dateRange: DateRange;
}
export const DATE_RANGE_PRESET: Record<PresetDateRangeKey, PresetDateRange> = {
  thisPeriod: {
    message: defineMessage({
      defaultMessage: "This billing period",
      id: "dateRanges.thisBillingPeriod",
    }),
    dateRange: [startOfMonth(now), endOfMonth(now)],
  },
  lastPeriod: {
    message: defineMessage({
      defaultMessage: "Last billing period",
      id: "dateRanges.lastBillingPeriod",
    }),
    dateRange: [startOfMonth(subMonths(now, 1)), startOfMonth(now)],
  },
  last14: {
    message: defineMessage({
      defaultMessage: "Last 14 days",
      id: "dateRanges.lastFourteenDays",
    }),
    dateRange: [subDays(now, 14), now],
  },
  last7: {
    message: defineMessage({
      defaultMessage: "Last 7 days",
      id: "dateRanges.lastSevenDays",
    }),
    dateRange: [subDays(now, 7), now],
  },
};
